import { OnInit, OnDestroy, HostListener, Directive } from '@angular/core';
import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UrlStoreService } from '../../services';
import { customSwal } from '../../../constants';

const SWAL_TITLES = {
  CANCEL_CONFIRMATION: `Are you sure, you want to Continue?`,
  DATA_LOST_WARNING: 'All the data on this page will be lost!',
  CONFIRM_BUTTON: 'Yes, go ahead!',
  CANCEL_BUTTON: 'No, I changed my Mind!'
} as const;

@Directive()
@Injectable()
export class RouteGuardGuard implements CanDeactivate<any>, OnInit, OnDestroy {
  private isDirtyWithChanges: boolean = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification(event: BeforeUnloadEvent): void {
    if (this.isDirtyWithChanges) {
      event.returnValue = true;
    }
  }

  constructor(public urlStoreService: UrlStoreService) {}

  ngOnInit() {
    console.log('HERE RouteGuardGuard INIT ------------>');
  }

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    console.log('HERE RouteGuardGuard Component------------>', component);
    console.log('currentRoute------------>', currentRoute);
    console.log('currentState------------>', currentState);
    console.log('nextState------------>', nextState);

    if (!this.urlStoreService.submitAction) {
      const isFormDirty = component.form?.dirty ?? false;
      const hasBizChangeEvent = component.hasOwnProperty('bizChangeEvent');
      const bizChangeEventValue = hasBizChangeEvent ? component.bizChangeEvent : false;
      const hasNoBizChanges = !hasBizChangeEvent || !bizChangeEventValue;

      if (isFormDirty && hasNoBizChanges) {
        console.log(
          'RouteGuard canDeactivate: IF CASE component.bizChangeEvent  ---->',
          hasBizChangeEvent ? component.bizChangeEvent : 'NULL'
        );

        console.log('component has property disable route guard', component.hasOwnProperty('disableRouteGuard'));
        console.log('component disable route guard true or false', component['disableRouteGuard']);

        const isGuardDisabled = component.hasOwnProperty('disableRouteGuard') && component['disableRouteGuard'];
        
        if (isGuardDisabled) {
          return true;
        } else {
          return this.waitForUser().then(value => {
            console.log('Value inside route-guard', value);
            return value;
          });
        }
      } else {
        console.log(
          'RouteGuard canDeactivate: ELSE CASE component.bizChangeEvent  ---->',
          hasBizChangeEvent ? component.bizChangeEvent : 'NULL'
        );
        return true;
      }
    } else {
      return true;
    }
  }

  waitForUser(): Promise<boolean> {
    return new Promise((resolve) => {
      try {
        console.log('waitForUser: pageChangeSwal executed');
        customSwal.fire({
          title: SWAL_TITLES.CANCEL_CONFIRMATION,
          text: SWAL_TITLES.DATA_LOST_WARNING,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: SWAL_TITLES.CONFIRM_BUTTON,
          cancelButtonText: SWAL_TITLES.CANCEL_BUTTON,
          reverseButtons: true
        }).then((result) => {
          resolve(result.value ?? false);
        });
      } catch (pageChangeSwalError) {
        console.log('waitForUser: pageChangeSwalError --->', pageChangeSwalError);
        resolve(false);
      }
    });
  }

  ngOnDestroy() {
    console.log('HERE RouteGuardGuard DESTROYED ------------>');
  }
}
